import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Header from '../components/Header/Header'
import ProjectsData from '../components/ProjectsData/ProjectsData'

const ProjectDetailspage = (props) => {
    const projectsData = useSelector((state) => state.projects)

    const [selectedProject, setSelectedProjects] = useState(null)

    useEffect(() => {
        const select = projectsData.filter((project) => (project.id === Number(props.match.params.id)))
        setSelectedProjects(select)
    }, [])

    const renderItems = <><Header projectsData={selectedProject} /><ProjectsData projectsData={selectedProject} /></>

    return (
        <>
            {selectedProject ? renderItems : <h1>"Loading..."</h1>}
        </>
    )
}

export default ProjectDetailspage
